<script>

import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions, mapState} from "vuex";
import TextPage from "@/pages/MyOutLine/TextPage.vue";

export default {
  name: "ChatDocManagement",
  components: {TextPage, AppBox, AppHeader},
  data() {
    return {
      subjectList: [''],
      subject: '',
      question: "",
    }
  },
  async mounted() {
    let docSubjectList = await this.getDocSubjectList();
    this.subjectList = this.subjectList.concat(docSubjectList.data);
  },
  computed: {
    ...mapState("fuzhu", ["chatDocContent", "chatDocContentLoading"])
  },
  methods: {
    ...mapActions("fuzhu", ["getDocSubjectList", "askDoc"]),
    onSubmit() {
      console.log(this.subject)
      if (this.question?.length > 0) {
        this.askDoc({question: this.question, subject: this.subject});
      }
    },
  }
}
</script>

<template>
  <div class="ChatDocManagement">
    <AppHeader>工单管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" size="small" ref="form">
          <el-form-item label="文档主题">
            <el-select
                style="width: 150px"
                v-model="subject"
            >
              <el-option
                  v-for="item in subjectList"
                  :key="item"
                  :label="item"
                  :value="item===''?'全部':item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="question"
                placeholder="问题"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-loading="chatDocContentLoading" type="primary" @click="onSubmit">提问</el-button>
          </el-form-item>
        </el-form>
        <el-card style="min-height: 70vh;width: 50vw">
          <el-input type="textarea" v-model="chatDocContent"></el-input>
        </el-card>
      </div>
    </AppBox>
  </div>
</template>

<style scoped lang="scss">
.ChatDocManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }

    ::v-deep .el-textarea__inner {
      border: unset;
      height: 65vh;
    }
  }
}
</style>